import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { platformGroupMutations } from "@/queries/platform-groups/mutations";
import { usePlatformGroupQueries } from "@/queries/platform-groups/queryOptions";

import { PlatformGroupsList, type PlatformGroupsListProps } from "./PlatformGroupsList";

const PLATFORM_GROUPS_LIMIT = 20;

export function ListPlatformGroupsPage(): React.ReactNode {
  const systemGroupQueries = usePlatformGroupQueries();
  const [page, setPage] = useState(0);
  const deleteGroupMutation = platformGroupMutations.useDeleteGroup();

  const platformGroupsQueryParams = {
    Offset: page * PLATFORM_GROUPS_LIMIT,
    Limit: PLATFORM_GROUPS_LIMIT,
  };

  const {
    data: platformGroups,
    isFetching: isFetchingPlatformGroups,
    error: errorLoadingPlatformGroups,
  } = useQuery(systemGroupQueries.list(platformGroupsQueryParams));

  const error = errorLoadingPlatformGroups;
  if (error) {
    return <ErrorPage error={error} />;
  }

  const totalPages = platformGroups ? Math.ceil(platformGroups.total / PLATFORM_GROUPS_LIMIT) : 0;

  const contentProps: PlatformGroupsListProps = {
    platformGroups: platformGroups?.items ?? [],
    isLoading: isFetchingPlatformGroups,
    page,
    onPageChange: setPage,
    totalPages,
    onDelete: deleteGroupMutation.mutateAsync,
  };

  return <PlatformGroupsList {...contentProps} />;
}
